import styled from 'styled-components';
// import media from '../../../styles/media.style';

export const Container = styled.div`
  margin: 50px auto;
  padding: 0 20px;
  width: 100%;
`;

export const Title = styled.div`
  font-size: 24px;
  text-align: center;
  line-height: 1.2;
  margin-bottom: 20px;
`;

export const Youtube = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  margin-bottom: 50px;
  iframe {
    position: absolute;
    top: 0;
    right: 0;
    width: 100% !important;
    height: 100% !important;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/ExtraPage/AMCAD/AMCAD.style.js